import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const AffectedItemsInvoiceErrorInternationalStepConfig: StepConfig = {
    type: FormType.AFFECTED_ITEMS_INVOICE_ERROR_INTERNATIONAL
};
